let ConfigurationType = /*#__PURE__*/function (ConfigurationType) {
  ConfigurationType["INBOUND"] = "INBOUND";
  ConfigurationType["MODULE"] = "MODULE";
  return ConfigurationType;
}({});
let ConfigurationState = /*#__PURE__*/function (ConfigurationState) {
  ConfigurationState["OK"] = "OK";
  ConfigurationState["DISABLED"] = "DISABLED";
  return ConfigurationState;
}({});

/**
 * Plain object Configuration representation.
 *
 */

/**
 * Plain object Packlink's API response representation.
 *
 */

/**
 * Plain object Packlink's API POST payload representation.
 *
 */

/**
 * Plain object Packlink's API PUT payload representation.
 *
 */

export { ConfigurationState, ConfigurationType };
//# sourceMappingURL=Configuration.js.map
